module.exports = __webpack_public_path__ + "img/couples-090.b15f09dd.jpg";